module.exports = __webpack_public_path__ + "img/trash-bin.da537f05.svg";